import { render, staticRenderFns } from "./PlantNavigationButton.vue?vue&type=template&id=1c26a3fa&scoped=true&"
import script from "./PlantNavigationButton.vue?vue&type=script&lang=ts&"
export * from "./PlantNavigationButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c26a3fa",
  null
  
)

export default component.exports